// extracted by mini-css-extract-plugin
module.exports = {"container":"GenadropTooltip_container__1keR4","card":"GenadropTooltip_card__2jfqA"};